// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Route, Routes } from "react-router-dom";

import { NotFound } from "~@jii/common-ui";
import { useSingleResidentContext } from "~@jii/data";
import {
  ReentryAssessment,
  UsNeCheckInTool,
  UsNeMoreInformation,
  UsNeReentryChecklist,
} from "~@jii/paths";

import { UsNeCheckInPage } from "./CheckInTool/UsNeCheckInPage";
import { Definition } from "./Definition/Definition";
import UsNeSingleResidentHome from "./Home/UsNeSingleResidentHome";
import { UsNeReentryAssessmentPage } from "./ReentryAssessment/UsNeReentryAssessmentPage";
import UsNeReentryChecklistPage from "./ReentryChecklist/UsNeReentryChecklistPage";
import { UsNeLayout } from "./UsNeLayout/UsNeLayout";

export const UsNeRouter = () => {
  const { residentFlags } = useSingleResidentContext();

  return (
    <Routes>
      <Route element={<UsNeLayout />}>
        <Route index element={<UsNeSingleResidentHome />} />
        <Route path={UsNeMoreInformation.path} element={<Definition />} />
        <Route
          path={UsNeReentryChecklist.path}
          element={<UsNeReentryChecklistPage />}
        />
        <Route
          path={ReentryAssessment.path}
          element={<UsNeReentryAssessmentPage />}
        />
      </Route>

      {/* Check-In Tool screens take over the entire layout and 
          skip the disclaimer footer */}
      {residentFlags.usNeCheckInTool && (
        <Route path={UsNeCheckInTool.path} element={<UsNeCheckInPage />} />
      )}

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
